import React, { type JSX } from 'react'
import { slugs } from '@/constants/slugs'
import {
  YoungWashingtonDetailsContent,
  SketchDetailsContent,
  SeniorDetailsContent,
  TruthAndTreasonDetailsContent,
  DavidDetailsContent,
  IwasDetailsContent,
  SoloMioDetailsContent,
} from '@/views/PreSales/PreSalesGiveawayView/config/giveaway-details-content/projects'
import { HomesteadSeriesDetailsContent } from '@/views/PreSales/PreSalesGiveawayView/config/giveaway-details-content/projects/homestead-series'

const DETAILS_CONFIGS: Record<string, React.ComponentType> = {
  [slugs.sketch]: SketchDetailsContent,
  [slugs.youngWashington]: YoungWashingtonDetailsContent,
  [slugs.senior]: SeniorDetailsContent,
  [slugs.truthAndTreason]: TruthAndTreasonDetailsContent,
  [slugs.david]: DavidDetailsContent,
  [slugs.iWasAStranger]: IwasDetailsContent,
  [slugs.soloMio]: SoloMioDetailsContent,
  [slugs.homesteadSeries]: HomesteadSeriesDetailsContent,
}

export const getGiveawayDetailsContent = (theatricalSlug: string): JSX.Element | null => {
  const Component = DETAILS_CONFIGS[theatricalSlug]
  return Component ? <Component /> : null
}
